module.exports = __webpack_public_path__ + "static/stairs_windows_night_mobile-5b556a18c1a1afb5b9188db531147d1f.jpg";